import { Chip, Container, Divider, Grid, Icon, Paper, Typography } from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import moment from 'moment';
import CreateMember from '../../containers/CreateMember';
import DataTable from '../common/DataTable';
import Filter from '../common/Filter';
import Header from '../common/Header/Header';
import Loading from '../common/Loading';
import NoResultsFound from '../common/NoResultsFound';
import UserAvatar from '../common/UserAvatar/UserAvatar';
import MemberFilterModal from '../Member/MemberFilterModal';
import styles from './styles';
import { SelectedPartnerMemberProps } from './types';
import UploadMembers from '../../containers/UploadMembers';

const periodLabels: { [key: string]: string } = {
    Last7Days: 'Last 7 Days',
    Last15Days: 'Last 15 Days',
    Last30Days: 'Last 30 Days',
    Last90Days: 'Last 90 Days',
};

const ViewSelectedPartnerMembers = ({
    user,
    memberData,
    memberColumns,
    memberLoadMore,
    memberHasMore,
    setOpenProfileDetails,
    openProfileDetails,
    onMemberSearchChange,
    handleRowClick,
    onDiabetesTypeChange,
    onMemberPeriodChange,
    onMemberStatusChange,
    selectedMemberPeriod,
    selectedMemberStatus,
    onMemberFilterChipDelete,
    onMemberFiltersApplyClick,
    onMemberFiltersClearClick,
    loader,
    selectedpartnerData,
    setCreateMember,
    createMember,
    setReload,
    fromSelectedPartner,
    diabetesTypeData,
    memberSortData,
    setViewPartner,
    reload,
    uploadMembers,
    setUploadMembers,
}: SelectedPartnerMemberProps) => {
    const onMemberChipDelete = (type: 'status' | 'diabetes' | 'additionPeriod', name?: string) => {
        if (onMemberFilterChipDelete) {
            onMemberFilterChipDelete(type, name);
        }
    };

    const chekedDiabetesType = diabetesTypeData.filter((a) => a.checked);

    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <Typography id="partner_member_title" component="div" sx={styles.header}>
                        <Typography id="partner_member_name" component="div" sx={styles.firstHeaderPartnerName}>
                            Partner & Members
                        </Typography>
                        <Typography
                            component="div"
                            sx={{
                                color: '#8697AB',
                            }}
                            id="partner_lessthan_icon"
                        >
                            {'<'}
                        </Typography>
                        <Typography id={selectedpartnerData?.name} sx={styles.firstHeaderEmployerName}>
                            {selectedpartnerData?.name}
                        </Typography>
                    </Typography>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />
            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.partner}>
                    <Grid container sx={styles.root}>
                        <Grid item xs={6} md={6} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                            <UserAvatar
                                name={`${selectedpartnerData?.name}`}
                                source={selectedpartnerData?.logoUrl || ''}
                                size={40}
                                radius="20px"
                                id="selected_partner_info"
                            />
                            <Typography>
                                <Typography sx={styles.secondHaderPartnerName}>{selectedpartnerData?.name}</Typography>
                                <Typography sx={styles.secondaryHeaderDate}>
                                    Added {moment(new Date(selectedpartnerData?.createdAt)).format('MMM DD, YYYY')}
                                </Typography>
                            </Typography>
                        </Grid>
                        <Grid
                            data-testid="edit-partner"
                            id="edit-partner"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            onClick={() => setViewPartner(true)}
                        >
                            <Typography sx={styles.editPartner} component="div">
                                View Partner
                                <VisibilityOutlinedIcon sx={styles.viewIcon} />
                            </Typography>
                        </Grid>
                    </Grid>
                </Typography>
            </Paper>

            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.partner}>
                    <Typography component="div">
                        <Filter
                            id="member-search"
                            onApplyFiltersClick={onMemberFiltersApplyClick}
                            onFiltersClearClick={onMemberFiltersClearClick}
                            placeholder="Search Members..."
                            searchChange={onMemberSearchChange}
                            modalContent={
                                <MemberFilterModal
                                    selectedMemberStatus={selectedMemberStatus}
                                    onMemberStatusChange={onMemberStatusChange}
                                    onMemberPeriodChange={onMemberPeriodChange}
                                    selectedMemberPeriod={selectedMemberPeriod}
                                    onDiabetesTypeChange={onDiabetesTypeChange}
                                    diabetesTypeData={diabetesTypeData}
                                />
                            }
                        />
                    </Typography>
                    <Typography component="div" sx={styles.selectedFilters}>
                        {selectedMemberStatus && (
                            <Chip
                                id="memberStatusChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onMemberChipDelete('status')}
                                label={selectedMemberStatus === 'active' ? 'Active' : 'Inactive'}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="/images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}{' '}
                        {selectedMemberPeriod && (
                            <Chip
                                id="memberPeriodChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onMemberChipDelete('additionPeriod')}
                                label={periodLabels[selectedMemberPeriod as string]}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="/images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}{' '}
                        {chekedDiabetesType.length !== 0 &&
                            chekedDiabetesType.map((dt) => (
                                <>
                                    <Chip
                                        key={dt.label}
                                        id="diabetesTypeChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onMemberChipDelete('diabetes', dt.label)}
                                        label={dt.label}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="/images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />{' '}
                                </>
                            ))}
                    </Typography>
                    {selectedpartnerData?.status === 'Active' && (
                        <Typography
                            id="export_member"
                            sx={styles.exportMember}
                            component="div"
                            onClick={() => setUploadMembers(true)}
                        >
                            Upload Members
                            <Typography
                                component="img"
                                alt="upload members"
                                src="/images/import.svg"
                                sx={styles.uploadIcon}
                            />
                        </Typography>
                    )}
                    {selectedpartnerData?.status === 'Active' && (
                        <Typography
                            id="add_new_member_selected_partner"
                            sx={styles.addMember}
                            component="div"
                            onClick={() => setCreateMember(true)}
                        >
                            Add New Member
                            <Typography component="img" alt="add member" src="/images/add.svg" sx={styles.addIcon} />
                        </Typography>
                    )}
                </Typography>

                <Divider sx={styles.divider} />
                {/* eslint-disable no-nested-ternary */}
                {loader ? (
                    <Loading />
                ) : memberData.length === 0 ? (
                    <NoResultsFound />
                ) : (
                    <DataTable
                        columns={memberColumns}
                        data={memberData}
                        loadMore={memberLoadMore}
                        hasMore={memberHasMore}
                        handleRowClick={handleRowClick}
                        sortData={memberSortData}
                    />
                )}
            </Paper>
            {createMember ? (
                <CreateMember
                    createMember={createMember}
                    setCreateMember={setCreateMember}
                    setReload={setReload}
                    fromSelectedPartner={fromSelectedPartner}
                    selectedPartner={selectedpartnerData}
                    partnerData={[{ ...selectedpartnerData }]}
                    reload={reload}
                />
            ) : null}
            {uploadMembers ? (
                <UploadMembers
                    uploadMembers={uploadMembers}
                    setUploadMembers={setUploadMembers}
                    setReload={setReload}
                    fromSelectedPartner={fromSelectedPartner}
                    selectedPartner={selectedpartnerData}
                    partnerData={[{ ...selectedpartnerData }]}
                    reload={reload}
                />
            ) : null}
        </Container>
    );
};

export default ViewSelectedPartnerMembers;
